import { Link as RouterLink } from 'react-router-dom';
import React,  {useContext} from 'react';
import { Helmet } from 'react-helmet';
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import ThemeProvider from '../theme';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../assets/contexts/userContext';
import usePageBackground from "../hooks/usePageBackground";
import { useFadeInOnScroll } from "../theme/global";
import '../css/global.css';
// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 680,
  margin: 'auto',
  minHeight: '80vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: theme.spacing(0),
  gap: theme.spacing(4),
}));

// ----------------------------------------------------------------------

export default function Page404() {

  const { user, logout } = useContext(UserContext);
  const isAdmin = user.hasRole('admin');
  const employee = user.hasRole('employee');
  const navigate = useNavigate();

  usePageBackground('page-404');
  const containerRef = useFadeInOnScroll();

  const handleClick = () =>
    user.isLogged
      ? isAdmin
        ? navigate('/admin/adminDashboard')
        : navigate('/employee/employeeDashboard')
      : navigate('/');


  return (
    <>
      <ThemeProvider>
      <Helmet>
        <title>Página no encontrada | CES</title>
        <meta name="description" content="La página solicitada no existe." />
      </Helmet>
      <Container ref={containerRef} className="fade-up" sx={{ p: 2 }}>
        <StyledContent >         

          <Typography variant='h4' sx={{ color: 'text.secondary',  fontWeight: 'fontWeightBold' }}>
            Lo sentimos, no hemos podido encontrar la página que estás buscando. Revisa la url.
          </Typography>
         
        <Button size="large" variant="contained" onClick={handleClick}>
          {user.isLogged ? 'Ir al panel principal' : 'Volver a inicio'}
        </Button>
        </StyledContent>
      </Container>
      </ThemeProvider>
    </>
  );
}
